export default "__VITE_ASSET__DrvQ1rqL__"